import React, { useEffect, useState } from 'react';
import api from '../api';

function Stocks() {
    const [stocks, setStocks] = useState([]);

    useEffect(() => {
        api.get('/stocks/symbols') 
            .then(response => setStocks(response.data))
            .catch(error => console.error("Error fetching stocks:", error));
    }, []);

    return (
        <div>
            <h1>Available Stocks</h1>
            <ul>
                {stocks.map(stock => (
                    <li key={stock}>{stock}</li>
                ))}
            </ul>
        </div>
    );
}

export default Stocks;
